import React, { useState, useEffect } from 'react';
import { Card, Button, Form, Input, message, Spin, Checkbox } from 'antd';
import { ArrowLeftOutlined, SearchOutlined, WarningOutlined } from '@ant-design/icons';
import axios from 'axios';
import './BackgroundCheck.css';

export default function BackgroundCheck({ id, navigateTo }) {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [housekeeperInfo, setHousekeeperInfo] = useState(null);
  const [agreed, setAgreed] = useState(false);

  useEffect(() => {
    loadHousekeeperInfo();
  }, [id]);

  const loadHousekeeperInfo = async () => {
    try {
      const token = localStorage.getItem('token');
      const res = await axios.get(`/api/housekeepers/${id}`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setHousekeeperInfo(res.data);
      form.setFieldsValue({
        name: res.data.name,
        id_card: res.data.id_card,
        phone: res.data.phone
      });
    } catch (error) {
      console.error('加载阿姨信息失败', error);
      message.error('加载阿姨信息失败');
    }
  };

  const handleSubmit = async (values) => {
    if (!agreed) {
      message.warning('请先勾选同意选项');
      return;
    }

    setLoading(true);
    try {
      const token = localStorage.getItem('token');
      const res = await axios.post(
        `/api/housekeepers/${id}/background-check`,
        values,
        { headers: { Authorization: `Bearer ${token}` } }
      );

      if (res.data.code === 200) {
        message.success('查询成功');
        navigateTo('background-check-result', { id, checkId: res.data.data.check_id });
      } else {
        message.error(res.data.message || '查询失败');
      }
    } catch (error) {
      console.error('背调查询失败', error);
      message.error('查询失败，请稍后重试');
    } finally {
      setLoading(false);
    }
  };

  const handleGoBack = () => {
    navigateTo('detail', { id });
  };

  // “修改信息”跳转到阿姨信息录入页（第一页）
  const goToEditInfo = () => {
    navigateTo('edit1', { id, mode: 'continue' });
  };

  return (
    <div className="bc-container">
      <Card
        title={
          <div className="bc-card-header">
            <Button icon={<ArrowLeftOutlined />} onClick={handleGoBack}>返回</Button>
            <span className="bc-card-title">信用查询</span>
          </div>
        }
      >
        <div className="bc-form">
          <div className="bc-form-description">
            请确认阿姨的身份信息进行信用查询
          </div>

          <Form
            form={form}
            layout="vertical"
            onFinish={handleSubmit}
            className="bc-form-content"
          >
            <Form.Item
              label="姓名"
              name="name"
              rules={[{ required: true, message: '请输入姓名' }]}
            >
              <Input disabled placeholder="请输入姓名" />
            </Form.Item>

            <Form.Item
              label="身份证号"
              name="id_card"
              rules={[{ required: true, message: '请输入身份证号' }]}
            >
              <Input disabled placeholder="请输入身份证号" />
            </Form.Item>

            <Form.Item
              label="手机号"
              name="phone"
              rules={[{ required: true, message: '请输入手机号' }]}
            >
              <Input disabled placeholder="请输入手机号" />
            </Form.Item>

            <div className="bc-warning-tip">
              <WarningOutlined className="bc-warning-icon" />
              <span className="bc-warning-text">
                查询将调用第三方接口，产生费用，请确认信息无误后提交
              </span>
            </div>
          </Form>
        </div>
      </Card>

      <div className="bc-bottom-action-area">
        <div className="bc-agreement-checkbox">
          <Checkbox
            checked={agreed}
            onChange={(e) => setAgreed(e.target.checked)}
          >
            <span className="bc-agreement-text"><strong>已征得被查询人本人同意</strong></span>
          </Checkbox>
        </div>

        <div className="bc-action-bar">
          <Button onClick={goToEditInfo} size="large">
            修改信息
          </Button>
          <Button
            type="primary"
            icon={<SearchOutlined />}
            loading={loading}
            disabled={!agreed}
            onClick={() => form.submit()}
            size="large"
          >
            开始查询
          </Button>
        </div>
      </div>
    </div>
  );
}
